import { Outside } from '@cian/ui-kit';
import { SuggestionPopup, IItemClickParams, IMultiSuggestResult, IMessageInfo } from '@cian/geosuggest-widget';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import * as stylesCommon from '../FiltersCommon/FiltersCommon.css';

import styles from './FilterRegion.css';

export interface IFilterRegionProps extends React.HTMLAttributes<HTMLDivElement> {
  suggestions: IMultiSuggestResult;
  suggestionError?: IMessageInfo;
  isSuggestionsAvailable: boolean;
  userInput: string;
  selectedRegionTitle?: string;

  onUserInput(query: string): void;

  setRegion(regionId: number, regionTitle: string): void;
}

export interface IFilterRegionState {
  active: boolean;
  selectedIndex: number;
}

export class FilterRegion extends React.Component<IFilterRegionProps, IFilterRegionState> {
  public constructor(props: IFilterRegionProps) {
    super(props);

    this.state = {
      active: false,
      selectedIndex: 0,
    };
  }

  public render() {
    const {
      suggestions,
      suggestionError,
      isSuggestionsAvailable,
      userInput,
      selectedRegionTitle,
      ...sharedProps
    } = this.props;
    const { active, selectedIndex } = this.state;

    return (
      <Outside onOutside={this.handleOutsideClick}>
        <div {...mergeStyles(stylesCommon['container'])} data-mark="FilterRegion" {...sharedProps}>
          <input
            {...mergeStyles(stylesCommon['input'], styles['input'])}
            placeholder={'Город'}
            value={active ? userInput : selectedRegionTitle}
            onFocus={this.handleInputFocus}
            onChange={this.handleValueChange}
          />
          {active && isSuggestionsAvailable && (
            <SuggestionPopup
              containerStyles={styles['dropdown']}
              suggestions={suggestions}
              selectedItem={selectedIndex}
              error={suggestionError}
              onItemSelect={this.handleItemSelect}
              onItemClick={this.handleItemClick}
            />
          )}
        </div>
      </Outside>
    );
  }

  private handleInputFocus = () => {
    this.setState({
      active: true,
    });
  };

  private handleValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.props.onUserInput(event.currentTarget.value);
  };

  private handleItemSelect = (selectedItem: number) => {
    this.setState({
      selectedIndex: selectedItem,
    });
  };

  private handleItemClick = (item: IItemClickParams) => {
    if (item.id) {
      this.props.setRegion(item.id, item.title);
    }

    this.setState({
      active: false,
    });
    this.props.onUserInput(item.title);
  };

  private handleOutsideClick = () => {
    this.setState({
      active: false,
    });
  };
}
